// extracted by mini-css-extract-plugin
module.exports = {"morebtn":"Tw874","fullWidth":"G9PFV","redBrdr":"BeCH0","redbg":"yfckQ","padding20":"b7AMb","smallSize":"j3GCJ","fWeight":"gFYKl","disabled":"QY7YR"};